import React, {Component} from "react";
import {Close, EmojiIco, File} from '../iconsSvg'
// components
import Emoji from '../Emoji';

export default class Input extends Component {
    state = {
        message: "",
        clientMessage: "",
        fileList: [],
        contentEditableSpanVisible: true,
        fileLoading: false,
    };

    replacementClientMessage = async mess => {
        let replacementClientMessage = await mess.replace(/&nbsp;/g, '');

        await replacementClientMessage.trim();

        if (replacementClientMessage !== "") {
            await this.props.onMessage({
                message: {type: "TEXT", text: replacementClientMessage.replace(/<br\s*\/?>/mg, "\n")},
                payload: {
                    type: "TEXT_SENDER",
                    payload: {"type": "TEXT", "text": replacementClientMessage.replace(/<br\s*\/?>/mg, "\n")}
                }
            });
            await this.setState({
                ...this.state,
                message: "",
                clientMessage: "",
                contentEditableSpanVisible: true
            }, () => this.contentEdit.innerHTML = '');

            if (this.props.mobilePhone === false) {
                this.contentEdit.focus();
            } else {
                this.contentEdit.blur()
            }
        }
    };

    changeFileLoading = param => this.setState({fileLoading: param})

    onSendMess = () => {
        if (this.props.previewFile !== false) {
            const postFile = (changeFileLoading) => {
                return new Promise((succeed, fail) => {
                    let xhr = new XMLHttpRequest();
                    let props = this.props;
                    xhr.open("POST", `${window.DOMAIN_NAME}/WebConnector/account/${window.ACCOUNT_ID}/session/${this.props.session || this.props.sessionParentComponent}/file`);

                    xhr.addEventListener("load", () => {
                        if (xhr.status >= 200 && xhr.status < 400) {
                            props.handlerSendFile();
                            succeed();
                            changeFileLoading(false)
                        } else {
                            // fail(new Error(`Request failed: ${xhr.statusText}`));
                        }
                    });
                    xhr.addEventListener("error", () => {
                        props.handlerSendFile();
                        changeFileLoading(false)
                        // fail(new Error("Network error"))
                    });

                    xhr.send(this.props.previewFile);
                })
            }

            this.setState({fileLoading: true}, () => {
                postFile(this.changeFileLoading)
                // .then(()=>console.log('1111')).catch(()=>console.log('2222'))
            })
        }

        if (this.state.clientMessage && this.state.clientMessage.indexOf('.png">') !== -1) {
            let tempArr = this.state.clientMessage.split('.png">');
            let myString = '';

            tempArr.map(el => {
                if (el.indexOf('/static/media') !== -1) {
                    let beforeSlise = el.slice(0, el.indexOf('<img'));

                    let firstSlice = el.slice(el.indexOf('/smile'));
                    let secondSlice = firstSlice.slice(0, firstSlice.indexOf('.'));

                    switch (secondSlice.slice(-1).trim()) {
                        case '1':
                            myString = `${beforeSlise} ♢:smiley:♢ ${myString}`;
                            break;
                        case '2':
                            myString = `${beforeSlise} ♢:sad:♢ ${myString}`;
                            break;
                        case '3':
                            myString = `${beforeSlise} ♢:wink:♢ ${myString}`;
                            break;
                        case '4':
                            myString = `${beforeSlise} ♢:angry:♢ ${myString}`;
                            break;
                        case '5':
                            myString = `${beforeSlise} ♢:oh:♢ ${myString}`;
                            break;
                        case '6':
                            myString = `${beforeSlise} ♢:like:♢ ${myString}`;
                            break;
                        case '7':
                            myString = `${beforeSlise} ♢:unlike:♢ ${myString}`;
                            break;
                    }
                } else {
                    myString = myString + el
                }
            });

            myString.replace(/&nbsp;/g, ' ');

            this.state.message && this.props.onMessage({
                type: {type: "TEXT", text: myString.replace(/<br\s*\/?>/mg, "\n")},
                payload: {
                    type: "TEXT_SENDER",
                    payload: {"type": "TEXT", "text": myString.replace(/<br\s*\/?>/mg, "\n")}
                }
            });

            this.setState({message: "", clientMessage: "", contentEditableSpanVisible: true});
            this.contentEdit.innerHTML = '';

            if (this.props.mobilePhone === false) {
                this.contentEdit.focus();
            } else {
                this.contentEdit.blur()
            }
        } else {
            this.replacementClientMessage(this.state.clientMessage);
        }
    };

    handlePaste = (e) => {
        let clipboardData, pastedData;

        e.stopPropagation();
        e.preventDefault();

        clipboardData = e.clipboardData || window.clipboardData;
        pastedData = clipboardData.getData('Text');

        this.contentEdit.innerHTML = (this.state.clientMessage + pastedData).replace(/&nbsp;/g, ' ');

        this.setState({
            contentEditableSpanVisible: false,
            clientMessage: (this.state.clientMessage + pastedData).replace(/&nbsp;/g, ' ')
        }, () => {
            if (this.props.mobilePhone === false) {
                this.handlerFocusContentEditable(this.contentEdit);
            }
        });
    };

    onMessage = () => {
        let divHtml = this.contentEdit.innerHTML;

        if (divHtml !== '' && divHtml.length > 0) {
            this.setState({
                    message: '',
                    clientMessage: '',
                    contentEditableSpanVisible: false,
                }, () => {
                    this.setState({message: divHtml, clientMessage: divHtml})
                }
            );
        } else {
            this.setState({
                contentEditableSpanVisible: true,
                message: '',
                clientMessage: ''
            });
        }
    };

    handleKeyPress = (e) => {
        if (e.shiftKey && e.keyCode === 13) {
            e.target.value += "\n";
        } else if (e.keyCode === 13) {
            e.preventDefault();
            this.onSendMess();
        }
    };

    handleChangeEmoji = emoji => {
        let divHtml = this.contentEdit;

        this.setState({
            contentEditableSpanVisible: false,
            message: this.state.message + `<img src='${emoji.img}' /> `,
            clientMessage: `${this.state.clientMessage} ♢${emoji.name}♢${' '}`
        }, () => {
            this.props.handleShowEmoji(false);
            divHtml.innerHTML = this.state.message;
            if (this.props.mobilePhone === false) {
                this.handlerFocusContentEditable(divHtml);
            }
        })
    };

    handlerFocusContentEditable = el => {
        el.focus();

        if (this.props.mobilePhone === false) {
            if (typeof window.getSelection !== "undefined" && typeof document.createRange !== "undefined") {
                let range = document.createRange();
                range.selectNodeContents(el);
                range.collapse(false);
                let sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof document.body.createTextRange !== "undefined") {
                let textRange = document.body.createTextRange();
                textRange.moveToElementText(el);
                textRange.collapse(false);
                textRange.select();
            }
        }
    };

    contentEditFocus = () => {
        this.props.handleShowEmoji(false);
        if (this.props.mobilePhone === false) {
            this.contentEdit.focus();
        }
    };

    render() {
        let {
            fontSize,
            previewFileName,
            handleShowEmoji,
            visibleEmojiBlock,
            handlerSendFile,
            onVisiblePreviewFile,
            access,
        } = this.props;
        const {fileLoading} = this.state;

        let chatLanguage = document.getElementById('chatLanguage');
        let lang = chatLanguage.getAttribute('data-language');

        const LetterLarge = <svg id="smLetterLarge" viewBox="0 0 289.8 342.7" width="19"
                                 style={{fill: fontSize === 'fs-large' && window.STYLE_FONT_ICON_ACTIVE_COLOR ? window.STYLE_FONT_ICON_ACTIVE_COLOR : '#999'}}
        >
            <g>
                <path className="st0" d="M202.7,31.7c-5-16.2-20-27.2-37-27.2h-42c-17,0-32,11.1-37,27.4L7.6,290.8c-3.4,11.2-1.4,23.5,5.7,32.9
            c7,9.4,18,15,29.8,15c16.7,0,31.3-11.1,35.7-27.2l16.3-58.6h95.7l17.5,58.2c4.9,16.3,20,27.5,37.1,27.5c12.3,0,23.9-5.8,31.2-15.7
            c7.3-9.9,9.4-22.7,5.8-34.4L202.7,31.7z M106,196.4l19.8-70.9c5.4-19.3,10.4-44.6,15.4-64.5h0.9c5,19.8,11,44.6,16.9,64.5
            l20.8,70.9H106z"/>
            </g>
        </svg>;
        const LetterMedium = <svg id="smLetterMedium" viewBox="0 0 289.8 342.7" width="14"
                                  style={{fill: fontSize === 'fs-medium' && window.STYLE_FONT_ICON_ACTIVE_COLOR ? window.STYLE_FONT_ICON_ACTIVE_COLOR : '#999'}}
        >
            <g>
                <path className="st0" d="M202.7,31.7c-5-16.2-20-27.2-37-27.2h-42c-17,0-32,11.1-37,27.4L7.6,290.8c-3.4,11.2-1.4,23.5,5.7,32.9
            c7,9.4,18,15,29.8,15c16.7,0,31.3-11.1,35.7-27.2l16.3-58.6h95.7l17.5,58.2c4.9,16.3,20,27.5,37.1,27.5c12.3,0,23.9-5.8,31.2-15.7
            c7.3-9.9,9.4-22.7,5.8-34.4L202.7,31.7z M106,196.4l19.8-70.9c5.4-19.3,10.4-44.6,15.4-64.5h0.9c5,19.8,11,44.6,16.9,64.5
            l20.8,70.9H106z"/>
            </g>
        </svg>;
        const LetterSmall = <svg id="smLetterSmall" viewBox="0 0 149.2 168.1" width="10"
                                 style={{fill: fontSize === 'fs-small' && window.STYLE_FONT_ICON_ACTIVE_COLOR ? window.STYLE_FONT_ICON_ACTIVE_COLOR : '#999'}}
        >
            <g>
                <path className="st0" d="M141,123.4V70.3c0-35.9-16.3-65.9-67.2-65.9c-18.9,0-34.7,3.5-46.1,7.6c-7.6,2.7-11.8,10.9-9.6,18.6l0.2,0.5
            c1.2,4.1,4,7.5,7.7,9.5c3.8,2,8.2,2.3,12.2,1c8.4-2.8,17.9-4.7,27.2-4.7c23.4,0,27.8,11.6,27.8,19.7v2.2
            C39.1,58.5,3.5,77.5,3.5,117.2c0,24.4,18.4,46.9,49.4,46.9c18.1,0,33.7-6.6,43.7-18.8h0.9l1.2,6.7c0.9,5,5.3,8.6,10.4,8.6h22.1
            c2.9,0,5.7-1.2,7.7-3.4c2-2.2,3-5,2.8-8C141.2,141.8,141,132.7,141,123.4z M94.7,105c0,2.8-0.3,5.6-0.9,8.1
            c-3.1,9.7-12.8,17.5-24.7,17.5c-10.6,0-18.8-5.9-18.8-18.1c0-18.4,19.4-24.4,44.4-24.1V105z"/>
            </g>
        </svg>;
        const SenderIco = <svg xmlns="http://www.w3.org/2000/svg" width="23.813" height="20.411"
                               viewBox="0 0 23.813 20.411">
            <path id="Path_600" data-name="Path 600" d="M2,23.411,25.813,13.205,2,3v7.938l17.009,2.268L2,15.473Z"
                  transform="translate(-2 -3)"
                  fill={`${window.STYLE_SEND_BUTTON_ICON_COLOR ? window.STYLE_SEND_BUTTON_ICON_COLOR : '#005ba8'}`}/>
        </svg>;

        return (
            <div
                className={`sm-overflow__hidden ${access ? 'with-menu' : ''} ${previewFileName ? 'with-preview' : ''}`}>

                {onVisiblePreviewFile && <span className="sm-preview-file-name">{File} <span>{previewFileName}</span> <b
                    onClick={handlerSendFile}>{Close}</b></span>}

                <div className={`sm-input-field ${visibleEmojiBlock ? 'emoji__show' : ''}`}
                     onKeyDown={this.handleKeyPress}>
                    {visibleEmojiBlock && <Emoji handleChangeEmoji={this.handleChangeEmoji}/>}

                    {this.state.contentEditableSpanVisible && lang !== '' && lang === 'ua' || this.state.contentEditableSpanVisible && lang !== '' && lang === 'uk' || this.state.contentEditableSpanVisible && lang !== '' && lang === 'ukr' && window.LOCALE_UA_INPUT_PLACEHOLDER ?
                        <span className="sm-contentEditable__span">{window.LOCALE_UA_INPUT_PLACEHOLDER}</span> : null}
                    {this.state.contentEditableSpanVisible && lang !== '' && lang === 'ru' || this.state.contentEditableSpanVisible && lang !== '' && lang === 'rus' && window.LOCALE_RU_INPUT_PLACEHOLDER ?
                        <span className="sm-contentEditable__span">{window.LOCALE_RU_INPUT_PLACEHOLDER}</span> : null}
                    {this.state.contentEditableSpanVisible && lang !== '' && lang === 'en' || this.state.contentEditableSpanVisible && lang !== '' && lang === 'eng' && window.LOCALE_EN_INPUT_PLACEHOLDER ?
                        <span className="sm-contentEditable__span">{window.LOCALE_EN_INPUT_PLACEHOLDER}</span> : null}
                    {this.state.contentEditableSpanVisible && lang !== '' && lang === 'uz' || this.state.contentEditableSpanVisible && lang !== '' && lang === 'uzb' && window.LOCALE_UZ_INPUT_PLACEHOLDER ?
                        <span className="sm-contentEditable__span">{window.LOCALE_UZ_INPUT_PLACEHOLDER}</span> : null}

                    <div contentEditable="true"
                         ref={node => this.contentEdit = node}
                         onKeyUp={e => this.onMessage(e)}
                         onClick={this.contentEditFocus}
                         onPaste={this.handlePaste}
                         className="sm-massage__input"
                         id="smMassageInput"
                    />

                    <div className="properties">
                        {window.EMOJI && <span onClick={() => handleShowEmoji(visibleEmojiBlock ? false : true)}
                                               className="sm-input__emoji">{EmojiIco}</span>}
                        {window.FILE_SENDER_BUTTON &&
                        <span onClick={this.props.handleShowDropZone} className="sm-input__file">{File}</span>}
                        <span onClick={() => this.props.handleChangeFontSize('fs-large')}
                              className={`sm-input__font ${fontSize === 'fs-large' ? 'active' : ''}`}>{LetterLarge}</span>
                        <span onClick={() => this.props.handleChangeFontSize('fs-medium')}
                              className={`sm-input__font ${fontSize === 'fs-medium' ? 'active' : ''}`}>{LetterMedium}</span>
                        <span onClick={() => this.props.handleChangeFontSize('fs-small')}
                              className={`sm-input__font ${fontSize === 'fs-small' ? 'active' : ''}`}>{LetterSmall}</span>
                        {fileLoading ? <span className="sm-isFileLoading"/> :
                            <span onClick={this.onSendMess} className="sm-input__send-btn">{SenderIco}</span>}
                        <div className="hide_bg" onClick={() => handleShowEmoji(false)}/>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Input/index.js